import { Link } from "react-router-dom";
import React, {useState, useEffect} from "react";
import axios from "axios";
import coursesLogo from "../Assets/coursesLogo.png";

export function RatingBtns({ value }) {
    const [userLocation, setUserLocation] = useState(null);
    const [distance, setDistance] = useState(null);

    console.log("value in RatingBtns is:",RatingBtns)

    useEffect(() => {
        // Get user's live location
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    setUserLocation({
                        latitude: position.coords.latitude,
                        longitude: position.coords.longitude,
                    });
                },
                (error) => console.error("Error fetching location:", error),
                { enableHighAccuracy: true }
            );
        } else {
            console.error("Geolocation is not supported by this browser.");
        }
    }, []);

    useEffect(() => {
        if (userLocation && value?.Institute?.Address) {
            fetchInstituteCoordinates(value.Institute.Address);
        }
    }, [userLocation, value]);

    // Convert address to coordinates using Google Maps API
    const fetchInstituteCoordinates = async (address) => {
        const API_KEY = "AIzaSyCWiF-rhJC5vG-_6akKZbSiJ1AIRxJe_mI"; // Replace with your API key
        const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(address)}&key=${API_KEY}`;

        try {
            const response = await axios.get(url);
            if (response.data.status === "OK") {
                const { lat, lng } = response.data.results[0].geometry.location;
                const instituteLocation = { latitude: lat, longitude: lng };

                // Calculate the distance
                const calculatedDistance = calculateDistance(userLocation, instituteLocation);
                setDistance(calculatedDistance);
            } else {
                console.error("Geocoding API error:", response.data.status);
            }
        } catch (error) {
            console.error("Error fetching coordinates:", error);
        }
    };

    // Haversine formula to calculate distance
    const calculateDistance = (user, institute) => {
        const toRad = (value) => (value * Math.PI) / 180;
        const R = 6371; // Radius of Earth in km
        const dLat = toRad(institute.latitude - user.latitude);
        const dLon = toRad(institute.longitude - user.longitude);
        const lat1 = toRad(user.latitude);
        const lat2 = toRad(institute.latitude);

        const a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

        return (R * c).toFixed(2); // Distance in km
    };

    // const formatDistance = (distance) => {
    //     if (distance >= 1000) {
    //       return `${(distance / 1000).toFixed(1)}k`;
    //     }
    //     return distance.toFixed(1); // still show 1 decimal for consistency
    // };

    const formatDistance = (distance) => {
        if (distance == null || isNaN(Number(distance))) return 'N/A'; // check after casting
        const distNum = Number(distance);
        if (distNum >= 1000) {
          return `${(distNum / 1000).toFixed(1)}k`;
        }
        return distNum.toFixed(1);
    };
           
    return (
        <div
            className={`mt-6 flex w-full items-center justify-between gap-3
            md:w-[100%] md:gap-4 lg:gap-0 xl:gap-6  `}
        >
            <div className="flex flex-col">
            {value?.AverageRating !== null ? (
                <span className="flex gap-1">
                {[...new Array(5)].map((_, index) => {
                        const roundedRating = Math.round(value.AverageRating || 0); // Round to nearest integer
                        return (
                        <img
                            key={index}
                            className="w-4"
                            src={
                           require("../../../CourseOverview/Assets/StarIcon.svg").default
                            }
                            alt="Star"
                        />
                        );
                    })}
                </span>
            ) : (
                <span className="flex gap-1">
                    <img
                        className="w-[115px]"
                        src={coursesLogo}                        
                        alt="coursesLogo"
                    />
                </span>
            )}

            {(value?.AverageRating !== null && value?.TotalStudentRatings > 0) && (
            <span className="SemiBold text-3xs">
                <img
                className="w-4"
                src={require("../../../LandingPage/PopularCourses/Assets/Thumb Icon.svg").default}
                alt="Thumb Icon"
                />{" "}
                {Math.round((value?.AverageRating / 5) * 100)}% ({value?.TotalStudentRatings})
            </span>
            ) }
                {/* <span className="SemiBold text-3xs">
                    <img
                        className="w-4"
                        src={
                            require("../../../LandingPage/PopularCourses/Assets/Thumb Icon.svg")
                                .default
                        }
                        alt=""
                    />{" "}
                    100% (3)
                </span> */}
            </div>
            <span className="text-end">
                <h5 className="Regularfont whitespace-nowrap text-[11px] font-thin md:text-[12px]">
                    {/* {value?.Institute?.InstituteName} */}
                    {value?.Institute?.InstituteName?.split(" ")[0]}
                </h5>
                <h5 className="Regularfont whitespace-nowrap  text-[11px] font-thin md:text-[12px]">
                    {value?.Institute?.State} | {value?.Institute?.City}
                </h5>
                {distance != null && !isNaN(distance) && (
                    <h5 className="Regularfont whitespace-nowrap text-[11px] font-thin md:text-[12px]">
                        Radius: {formatDistance(distance)} km
                    </h5>
                )}

                {/* {distance && (
                <h5 className="Regularfont whitespace-nowrap text-[11px] font-thin md:text-[12px]">
                    Radius: {formatDistance(distance)} km
                </h5>
                )} */}
            </span>
        </div>
    );
}

export function CourseInfo({ value, Path }) {
    let Description = value?.Description;

    if (value?.Description.length > 125)
        Description =
            value?.Description.split("").slice(0, 60).join("") + " ...";

    let CourseName = value?.CourseName;

    if (value?.Description.length > 125)
        CourseName = value?.CourseName.split("").slice(0, 30).join("") + " ...";

    return (
        <Link
            to={Path}
            className="flex flex-col items-center gap-2 text-black no-underline w-full"
        >
             
                <div className="w-full">
            <h2 className="Blackfont px-2 text-center  h-6 w-full truncate  text-[12px] md:text-3xs transition-all delay-300 hover:text-clip  hover:whitespace-normal	hover:h-auto  ">
                {CourseName}
            </h2>
           

            </div>
            
           

            <p className="Regularfont h-16 bg-blend-overlay max-w-[250px] overflow-y-auto text-center text-[12px] md:text-4xs ">
                {Description}
            </p>
          
            
        </Link>
    );
}
